import { CanActivateFn, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { PermissionsService } from '../services/permissions.service';
import { HelpersService } from '../services/helpers.service';

export const permissionGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot
): Promise<boolean | UrlTree> => {
  const permissions = inject(PermissionsService);
  const helpers = inject(HelpersService);
  const router = inject(Router);

  const claimType = route.data?.['claimType'];
  const requiresDirector = route.data?.['isDirector'];
  const allowRoles: string[] | undefined = route.data?.['allowRoles'];

  if (requiresDirector) {
    return helpers.isDirector() ? true : router.createUrlTree(['/not-authorized']);
  }

  if (allowRoles?.includes(helpers.role_id())) {
    return true;
  }

  if (!claimType) {
    return true;
  }

  const claims = await permissions.getAllClaims();
  return permissions.hasPermission(claims ?? [], claimType)
    ? true
    : router.createUrlTree(['/not-authorized']);
};
